let zopimInitComplete = false,
  titleInterval = null,
  zopimInit = function zopimInit() {
    var ua = navigator.userAgent.toLowerCase(),
      platform = navigator.platform.toLowerCase(),
      platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
      isMobile = /ios|android|webos/.test(platformName);

    if (!isMobile) {
      // Start of Zopim Live Chat Script
      window.$zopim || (function(d, s) {
        var z = window.$zopim = function(c) { z._.push(c) },
          $ = z.s =
          d.createElement(s),
          e = d.getElementsByTagName(s)[0];
        z.set = function(o) {
          z.set.
          _.push(o)
        };
        z._ = [];
        z.set._ = [];
        $.async = !0;
        $.setAttribute("charset", "utf-8");
        $.src = "//v2.zopim.com/?2G49jHUlZLgQk1REVPOugqzWNNxQsU6a";
        z.t = +new Date;
        $.
        type = "text/javascript";
        e.parentNode.insertBefore($, e)
      })(document, "script");
      // End of Zopim Live Chat Script
      window.$zopim(function() {
        $zopim.livechat.departments.filter('Customer Service');
        $zopim.livechat.departments.setVisitorDepartment('Customer Service');
      });

      titleInterval = setInterval(() => {
        if ($('iframe[data-test-id="ChatWidgetButton-iframe"').length) {
          $('iframe[data-test-id="ChatWidgetButton-iframe"').attr('title', 'live chat widget');
          clearInterval(titleInterval);
        }
      }, 100);
    }

    $(document).on('click', '[live-chat]', (e) => {
      e.preventDefault();
      if (!window.$zopim) return;
      $zopim.livechat.window.show();
      $('.zopim').removeClass('off-whitelist');
    });

    zopimInitComplete = true;
  }

const WHITELIST = [
  'contact',
  'faq',
  'about',
  'partnerships',
  'press',
  'how-it-works',
  'features',
  'track-order',
  'order-summary',
  'academy',
];

export default [
  '$state', '$location',
  function zopimLiveChat($state, $location) {
    function checkWhitelist() {
      return !!_.find(WHITELIST, (w) => {
        let found = false;
        if ($state.includes(w)) found = true;
        if ($state.is(w)) found = true;
        if ($location.url().indexOf(w) > -1) found = true;
        return found;
      });
    }

    return {
      restrict: 'E',
      link: () => {
        if (!zopimInitComplete) zopimInit();

        if (!checkWhitelist()) {
          $('.zopim').addClass('off-whitelist');
        }
      }
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/layout-components/live-chat/live-chat.dir.js